import api_config from "@/utils/api_config";
import store from "@/store";
import router from "@/router";
import { Notification } from "element-ui";
class WebSocketManager {
  constructor() {
    this.ws = null;
    this.baseUrl = api_config.webScoketUrl;
    this.url = api_config.webScoketUrl;
    this.reconnectInterval = 5000;
    this.heartbeatInterval = 30000;
    this.heartbeatTimer = null;
    this.reconnectTimer = null;
    this.isManualClose = false;
  }

  connect(token) {
    if (
      this.ws &&
      (this.ws.readyState === WebSocket.OPEN ||
        this.ws.readyState === WebSocket.CONNECTING)
    ) {
      return;
    }

    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }

    this.url = `${this.baseUrl}?Authorization=${token}`;
    this.isManualClose = false;
    this.createWebSocket();
  }

  createWebSocket() {
    try {
      this.ws = new WebSocket(this.url);

      this.ws.onopen = () => {
        console.log("WebSocket 连接成功");
        this.startHeartbeat();
      };

      this.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          // 门店信息
          if (data.type === "ChainStoreList") {
            store.dispatch("websocket/updateChainStoreList", data.data);
          }
          // 处方信息
          if (data.type === "PreAuditPrescriptionList") {
            store.dispatch(
              "websocket/updatePreAuditPrescriptionList",
              data.data
            );
          }
          // 登出
          if (data.type === "Logout") {
            Notification({
              title: data.data.title,
              type: "error",
              message: data.data.message,
              dangerouslyUseHTMLString: true,
              position: "bottom-right",
              duration: 4000,
              customClass: "notify-error-title",
            });
            store.dispatch("user/logout");
            router.push(`/login`);
          }
        } catch (e) {
          console.log("WebSocket 消息（非JSON格式）:", event.data);
        }
      };

      this.ws.onerror = (error) => {
        console.error("WebSocket 错误:", error);
      };

      this.ws.onclose = (event) => {
        console.log("WebSocket 连接关闭", event);
        this.stopHeartbeat();
        if (!this.isManualClose) {
          console.log("准备重新连接...");
          this.reconnect();
        }
      };
    } catch (error) {
      console.error("创建 WebSocket 失败:", error);
      this.ws = null;
      if (!this.isManualClose) {
        this.reconnect();
      }
    }
  }

  startHeartbeat() {
    this.stopHeartbeat();
    this.heartbeatTimer = setInterval(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify({ type: "heartbeat" }));
      }
    }, this.heartbeatInterval);
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }

  reconnect() {
    this.stopHeartbeat();
    this.reconnectTimer = setTimeout(() => {
      console.log("正在重新连接 WebSocket...");
      this.createWebSocket();
    }, this.reconnectInterval);
  }

  close() {
    this.isManualClose = true;
    this.stopHeartbeat();
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.ws) {
      this.ws.onopen = null;
      this.ws.onmessage = null;
      this.ws.onerror = null;
      this.ws.onclose = null;
      this.ws.close();
      this.ws = null;
    }
  }

  send(data) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(data));
    } else {
      console.warn("WebSocket 未连接，无法发送消息");
    }
  }
}

const wsManager = new WebSocketManager();

export default wsManager;
